const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const KEY = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const ROLES = ['owner', 'admin', 'marketer', 'viewer'];
export function canManageCompanyInvitation(member, actorRole, companyId) {
  return ['owner', 'admin'].includes(actorRole) && UUID.test(companyId || '')
    && member?.companyId === companyId && UUID.test(member.id || '') && member.status === 'invited'
    && Number.isSafeInteger(member.revision) && member.revision >= 0 && ROLES.includes(member.role)
    && (actorRole === 'owner' || member.role !== 'owner');
}
export function invitationCooldown(member, now = Date.now()) {
  const deadline = Date.parse(member?.nextAllowedAt);
  return Number.isFinite(deadline) ? Math.max(0, Math.ceil((deadline - now) / 1000)) : 0;
}
export function invitationDeliveryLabel(member) {
  if (member?.deliveryStatus === 'failed') return member.failureCategory === 'unknown' ? 'Delivery unconfirmed' : 'Email failed';
  return { pending: member?.deliveryKind ? 'Delivery pending' : 'Not sent', sent: 'Invitation sent', recovery_sent: 'Reset requested', accepted: 'Accepted', canceled: 'Canceled' }[member?.deliveryStatus] || 'Invitation pending';
}
function storageKey(companyId, actorId) { return `bl:invitation-action:${actorId}:${companyId}`; }
function validAttempt(value, companyId, actorId) {
  const body = value?.body;
  return UUID.test(companyId || '') && UUID.test(actorId || '') && value?.companyId === companyId && value.actorId === actorId
    && UUID.test(value.invitationId || '') && KEY.test(body?.actionKey || '')
    && ['role', 'resend', 'recover', 'cancel'].includes(body.action) && Number.isSafeInteger(body.expectedRevision) && body.expectedRevision >= 0
    && (body.action === 'role' ? ROLES.includes(body.role) : body.role === undefined)
    && Object.keys(body).every(key => ['action', 'actionKey', 'expectedRevision', 'role'].includes(key));
}
export function readInvitationAttempt(storage, companyId, actorId) {
  try { const value = JSON.parse(storage.getItem(storageKey(companyId, actorId)) || 'null'); return validAttempt(value, companyId, actorId) ? value : null; } catch { return null; }
}
export function saveInvitationAttempt(storage, value) {
  if (!validAttempt(value, value?.companyId, value?.actorId)) throw new Error('invalid_invitation_attempt');
  try {
    const previous = readInvitationAttempt(storage, value.companyId, value.actorId);
    if (previous && JSON.stringify(previous) !== JSON.stringify(value)) throw new Error();
    storage.setItem(storageKey(value.companyId, value.actorId), JSON.stringify(value));
    if (JSON.stringify(readInvitationAttempt(storage, value.companyId, value.actorId)) !== JSON.stringify(value)) throw new Error();
  } catch { throw new Error('invitation_continuation_unavailable'); }
  return value;
}
export function clearInvitationAttempt(storage, companyId, actorId) {
  try { storage.removeItem(storageKey(companyId, actorId)); } catch {}
}
export function checkedInvitationCommand(result, attempt) {
  const row = result?.invitation;
  const allowedStatuses = result?.replayed === true
    ? ['invited', 'active', 'canceled', 'disabled', 'removed']
    : ['invited', 'active', 'canceled'];
  if (!row || !UUID.test(row.id || '') || row.companyId !== attempt.companyId || !ROLES.includes(row.role)
    || !Number.isSafeInteger(row.revision) || row.revision < attempt.body.expectedRevision
    || !allowedStatuses.includes(row.status)
    || (attempt.body.action === 'role' ? row.id === attempt.invitationId || (result.replayed !== true && row.role !== attempt.body.role) : row.id !== attempt.invitationId)) throw new Error('invitation_result_unconfirmed');
  return result;
}
